<div class="palantir-scrollbar relative h-full overflow-auto" (paste)="handlePaste($event)">
  <div class="flex w-full gap-2">
    <div class="palantir-scrollbar rounded-lg border border-gray-200">
      <table
        class="palantir-scrollbar w-full border-separate border-spacing-0 text-left text-sm text-gray-500"
      >
        <thead class="border-b text-xs uppercase text-gray-700">
          <tr>
            <!-- Corner cell for row actions -->
            <th
              scope="col"
              class="sticky left-0 z-10 w-12 border-r border-gray-200 bg-gray-90/50 px-2 py-3"
            >
              @if (!hideFullScreen()) {
                <button
                  (click)="openInFullscreen()"
                  class="rounded-full p-1"
                  palantirTooltip="Abrir em tela cheia"
                  [palantirTooltipDelay]="300"
                  type="button"
                >
                  <palantir-icon
                    name="fullscreen-outline"
                    class="h-4 w-4 text-base text-black"
                  ></palantir-icon>
                </button>
              }
            </th>
            @for (col of data()[0] || []; track $index; let colIndex = $index) {
              <th
                scope="col"
                class="group relative border-r border-gray-200 bg-gray-90/50 px-6 py-3 last:border-r-0"
              >
                <fx-dynamic-tabular-table-header-cell
                  [columnHeader]="getColumnHeader(colIndex)!"
                  [readonly]="readonly()"
                  [canRemove]="canRemoveColumn()"
                  (remove)="removeColumn(colIndex)"
                />
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (
            row of data();
            track $index;
            let rowIndex = $index;
            let odd = $odd;
            let isLast = $last
          ) {
            <tr
              class="group hover:bg-blue-50/5"
              [class.bg-gray-98]="odd"
              [class.border-b]="!isLast"
            >
              <td
                class="sticky left-0 z-10 border-r border-gray-200 px-2 py-2 last:border-r-0 group-hover:bg-blue-50/5"
                [class.bg-gray-98]="odd"
              >
                <fx-dynamic-tabular-table-row-actions
                  [rowIndex]="rowIndex"
                  [readonly]="readonly()"
                  [canRemove]="canRemoveRow() && (canEditFirstRow() || rowIndex > 0)"
                  [odd]="odd"
                  (remove)="removeRow(rowIndex)"
                />
              </td>
              @for (cell of row; track $index; let colIndex = $index) {
                <td class="border-r border-gray-200 px-2 py-1 last:border-r-0">
                  <fx-dynamic-tabular-table-cell
                    [value]="cell"
                    [isEditing]="isEditing(rowIndex, colIndex)"
                    [columnType]="getColumnType(colIndex)"
                    [readonly]="readonly()"
                    [tabindex]="readonly() || (!canEditFirstRow() && rowIndex === 0) ? '-1' : '0'"
                    [skipFormatting]="!canEditFirstRow() && rowIndex === 0"
                    (cellClick)="editCell(rowIndex, colIndex)"
                    (cellBlur)="updateCellValue($event, rowIndex, colIndex)"
                    (cellKeydown)="handleCellKeydown($event, rowIndex, colIndex)"
                  />
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
    @if (!readonly() && numCols() < COLUMN_LIMIT && canAddColumn()) {
      <div class="w-12 px-2 py-3">
        <button
          (click)="addColumn()"
          type="button"
          class="flex h-full w-full items-center justify-center rounded-md text-gray-400 transition-colors hover:bg-gray-200 hover:text-blue-500"
        >
          <palantir-icon name="add-outline"></palantir-icon>
        </button>
      </div>
    }
  </div>

  @if (!readonly() && numRows() < ROW_LIMIT && canAddRow()) {
    <div class="mt-2 flex items-center">
      <button
        (click)="addRow()"
        type="button"
        class="flex items-center space-x-2 rounded-md px-3 py-1 text-sm text-gray-500 transition-colors hover:bg-gray-100 hover:text-blue-600"
      >
        <palantir-icon name="add-outline"></palantir-icon>
        <span>Adicionar Linha</span>
      </button>
    </div>
  }

  @if (data().length === 0) {
    <fx-dynamic-tabular-table-empty-state [readonly]="readonly()" />
  }
</div>
